"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareOnSocials = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var SocialShareService_1 = require("@CommonFrontend/SocialShare/SocialShareService");
var c = (0, BemBuilder_1.default)("share-on-socials");
function ShareOnSocials(_a) {
    var projectName = _a.projectName, linkUrl = _a.linkUrl;
    var _b = (0, SocialShareService_1.getSocialLinks)(projectName, linkUrl, SocialShareService_1.SocialShareUtmMedium.InAppShare), twitter = _b.twitter, facebook = _b.facebook, linkedin = _b.linkedin;
    var buttons = [
        {
            icon: react_1.default.createElement(icons_1.Linkedin, null),
            href: linkedin,
        },
        {
            icon: react_1.default.createElement(icons_1.Twitter, null),
            href: twitter,
        },
        {
            icon: react_1.default.createElement(icons_1.Facebook, null),
            href: facebook,
        },
    ];
    return (react_1.default.createElement("div", { className: c() },
        react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true, secondary: true }, "Share on socials"),
        react_1.default.createElement("div", { className: c("buttons") }, buttons.map(function (_a, index) {
            var icon = _a.icon, href = _a.href;
            return (react_1.default.createElement(kaleidoscope_1.IconButton, { className: c("icon"), key: index, icon: icon, href: function () { return href; }, size: kaleidoscope_1.ButtonSize.Small, isRound: true }));
        }))));
}
exports.ShareOnSocials = ShareOnSocials;
